/* istanbul ignore file */
const initInlineManual = () => {
  window.createInlineManualPlayer(window.inlineManualPlayerData);
};

export const updateInlineManual = () => {
  if (window.inline_manual_player) {
    window.inline_manual_player.update();
  }
};

export function getInlineManualUrl() {
  return `https://inlinemanual.com/embed/player.${process.env.INLINE_MANUAL_KEY}.bare.js`;
}

export default initInlineManual;
